import React from 'react'
import { connect } from 'react-redux'
import { Link, IndexLink } from 'react-router'

import { logout } from '../actions'

class Header extends React.Component {
    render() {
        const { user, activeCallsCount, maintenanceInfo, logout } = this.props
        return (
            <header id="header">
                <Link to="/"><img src="img/SRGSSR.png" alt="SRG/SSR" className="logo" /></Link>
                <div className="title">Audio over IP {user && user.roles && user.roles.filter(r => r.role === 'admin').length > 0 && 'Admin'}</div>
                {user &&
                    <nav>
                        <IndexLink to="/" activeClassName="active">Home</IndexLink>
                        <Link to="/calls" activeClassName="active">Active Calls ({activeCallsCount})</Link>
                        {user && user.roles && user.roles.filter(r => r.role === 'admin').length > 0 &&
                            <Link to="/create" activeClassName="active">Add subscriber</Link>
                        }
                        {/* <Link to="/help" activeClassName="active">Help</Link> */}
                        <a href="/AoIP_HB_Webinterface_DE.pdf" target="_blank">Help</a>
                        {(maintenanceInfo || user.isGlobalAdmin) &&
                            <Link to="/maintenance" activeClassName="active">Maintenance</Link>
                        }
                    </nav>
                }
                {user &&
                    <div>
                        {user.displayName || user.id}&nbsp;
                    <a href="#" onClick={e => { e.preventDefault(); logout(); }}>[Logout]</a>
                    </div>
                }
            </header>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        activeCallsCount: state.calls.length,
        maintenanceInfo: state.config.maintenanceInfo
    }
}

export default connect(mapStateToProps, { logout })(Header)


// WEBPACK FOOTER //
// ./containers/Header.jsx